module.exports = __webpack_public_path__ + "assets/images/joinmember-2QOd-V_.jpg";